<template>
    <CModal :title="dialogTitle" :show.sync="dialogVisible">
        <CForm slot="default">
            <CInput
                v-model="model.title"
                :horizontal="true"
                label="Название"
                placeholder="Название категории"
            />
        </CForm>

        <div slot="footer">
            <CButton
                color="light"
                class="ml-3"
                @click="close">Отмена</CButton>
            <CButton
                color="primary"
                class="ml-3"
                @click="submit">{{
                    submitButtonTitle
                }}</CButton>
        </div>
    </CModal>
</template>

<script>
    export default {
        name: 'AssistantCategoryUpsertDialog',

        props: {
            entity: {
                type: Object,
                default: () => ({}),
            },
        },

        data: () => ({
            dialogVisible: false,
            model: {},
        }),

        computed: {
            dialogTitle() {
                return typeof this.entity.id === 'number'
                    ? 'Редатирование категории'
                    : 'Создание категории';
            },

            submitButtonTitle() {
                return typeof this.entity.id === 'number' ? 'Сохранить' : 'Создать';
            },
        },

        watch: {
            dialogVisible: function (v) {
                if (v) {
                    this.setModel(this.entity);
                }
            },
        },

        methods: {
            open() {
                this.dialogVisible = true;
            },

            close() {
                this.dialogVisible = false;
            },

            setModel(source) {
                this.model = source;
            },

            async submit() {
                if (!this.model.title) {
                    this.$root.$emit('showError', 'Название категории не может быть пустым.');
                    return;
                }

                try {
                    const { id, ...payload } = this.model;

                    if (typeof id === 'number') {
                        await this.axios.put(
                            `/assistants/${payload.assistant_id}/categories/${id}`,
                            payload
                        );
                    } else {
                        await this.axios.post(
                            `/assistants/${payload.assistant_id}/categories`,
                            payload
                        );
                    }

                    this.$emit('success');
                    this.close();
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка создания/редактирования категории. ' + err);
                }
            },
        },
    };
</script>
